import React from "react";
import { Handle, Position } from "@xyflow/react";
import { FaShopify } from "react-icons/fa";

const labels = {
  "orders/create": "Order created",
  "orders/paid": "Order paid",
  "orders/fulfilled": "Order fulfilled",
  "orders/cancelled": "Order cancelled",
};

export default function ShopifyTriggerNode({ data, selected }) {
  return (
    <div className={`rounded-xl border-2 bg-surface-card shadow-sm min-w-[210px] transition-shadow ${selected ? "border-emerald-500 shadow-md" : "border-surface-border"}`}>
      <div className="flex items-center gap-2 px-3 py-2 rounded-t-[10px] bg-emerald-600">
        <FaShopify size={12} className="text-white" />
        <span className="text-xs font-semibold text-white">Shopify Event</span>
      </div>
      <div className="px-3 py-2.5">
        <p className="text-xs font-medium text-ink-primary">
          {labels[data.topic] || "Click to configure"}
        </p>
        {data.integrationName && (
          <p className="mt-0.5 text-2xs text-ink-muted truncate">{data.integrationName}</p>
        )}
      </div>
      <Handle type="source" position={Position.Bottom} className="!w-3 !h-3 !bg-emerald-600 !border-2 !border-white" />
    </div>
  );
}
